import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import ReadOnlyTextField from "../../../Components/readOnlyTextField/readOnlyTextField";
import Alert from "../../../Components/alert/Alert";
import Select from "../../../Components/select/select";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";

export default class delDepartment extends React.Component {
  state = {
    departments: [],
    departmentids: [],
    description: "",
    code: null,
    id: 0,
    show: false,
    message: "",
    factorys: [],
    factorysAllProps: [],
    notification: false,
    notification_type: 'success',
    notification_message: ''
  };

  componentDidMount() {
    Api.get("/departments/").then((resp) => {
      this.setState({ departmentids: [...resp.data] });
    });
    Api.get("/factorys/").then((resp) => {
      let factorys = [];
      resp.data.forEach((element) => {
        factorys.push({ value: element.id, label:element.description });
      });
      this.setState({ factorys: factorys, factorysAllProps: [...resp.data] });
    });
  }

  SelectedDepartment = (childData) => {
    const { id, description, code } = this.state.departmentids.find(
      (value) => value.id === childData
    );
    this.setState({ id: id, description: description, code: code });
  };
  SelectFactory = (childData) => {
    const { id } = this.state.factorysAllProps.find(
      (v) => v.id === childData
    );
    let arrDeparts = [...this.state.departmentids];
    let result = arrDeparts.filter((e) => e.id_factory === id);
    let arraDeps = [];
    result.forEach(el => {arraDeps.push({ value:el.id, label:el.description })})
    this.setState({ departments: arraDeps });
  };

  sendData = async (id) => {
    if (this.state.id !== 0) {
      await Api.delete(`/departments/${id}`, {
        code: this.state.code,
        description: this.state.description,
      })
        .then((resp) => {
          this.setState({notification: true, notification_message: "Setor deletado com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
        })
        .catch((error) => {
          if (error.response) {

            if(error.response.status == 401){
              this.setState({
                show: true,
                message:"Erro ao deletar! Uma máquina depende desse registro."
              });
            }else{
              this.setState({
                show: true,
                message:
                  "" +
                  error.response.data +
                  "\n" +
                  error.response.status +
                  "\n" +
                  error.response.headers,
              });
            }

            
          }
        });
    } else {
      this.setState({ show: true, message: "Necessário selecionar o setor." });
    }
  };

  changeValue = (value) => {
    this.setState({ description: value.target.value });
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  render() {
    let { show, message, notification, notification_message, notification_type} = this.state;
    return (
      <div className="box">
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <div className="input_fields_del_depart form">
        <h4>Deletar Setor</h4>
          {show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
            />
          ) : null}
          <div className="inputs">
          <div className='select1DelDepart element'>
            <Select
              autoSelect={true}
              label="Selecionar Planta"
              arrData={this.state.factorys}
              handleSelect={this.SelectFactory}
            />
          </div>
          <div className='select2DelDepart element'>
            <Select
              label="Selecionar Setor"
              arrData={this.state.departments}
              handleSelect={this.SelectedDepartment}
            />
          </div>
          <div className='tf1DelDepart element'>
            <ReadOnlyTextField title="Código" showValue={this.state.code} />
          </div>
          <div className='tf1DelDepart element'>
            <ReadOnlyTextField
              title="Descrição"
              showValue={this.state.description}
            />
          </div>
          </div>
          <div className='btnDelDepart submitButton'>
            <Button
              title="Deletar"
              parentCallback={() => this.sendData(this.state.id)}
            />
          </div>
        </div>
      </div>
    );
  }
}